import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {updateStartGuideTasksAction} from '../../../store/data/preferences/preferencesActions';
import {AdminOnboardingGuide} from './adminOnboardingGuide';

/*
 * Props.
 */

interface AdminOnboardingGuideContainerProps {}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<AdminOnboardingGuideContainerProps>()(() => ({
  updateStartGuideTasks: updateStartGuideTasksAction,
}));

export const AdminOnboardingGuideContainer = connect(null, mapDispatchToProps)(AdminOnboardingGuide);
